// @flow

import * as React from 'react';
import styled from 'styled-components';
import Spinner from 'seedling/components/loading_spinner';
import Button from 'seedling/components/button';
import { colors, padding } from 'seedling/constants';

type RowProps = {
  compact?: boolean,
  children: React.Node,
  extraAction?: React.Node,
};

type SubmitProps = {
  children: React.Node,
  isSubmitting?: boolean,
  fancy?: boolean,
};

type CancelProps = {
  children: React.Node,
  onCancel?: () => void,
};

const Row = ({
  compact = false,
  children,
  extraAction,
  ...otherProps
}: RowProps) => {
  return (
    <Container
      compact={compact}
      className="form-submit-buttons"
      {...otherProps}
    >
      {extraAction && <ControlSet className="extra">{extraAction}</ControlSet>}
      <ControlSet className="standard">{children}</ControlSet>
    </Container>
  );
};

const Cancel = ({ onCancel, children, ...otherProps }: CancelProps) => {
  function cancel(event: SyntheticEvent<HTMLButtonElement>) {
    event.preventDefault();

    if (onCancel) {
      onCancel();
    }
  }

  return (
    <CancelLink href="#" onClick={cancel} {...otherProps}>
      {children}
    </CancelLink>
  );
};

const Submit = ({
  onSubmit,
  children,
  isSubmitting = false,
  fancy = false,
  ...otherProps
}: SubmitProps) => {
  return (
    <Button style={{ marginLeft: 15 }} fancy={fancy} {...otherProps}>
      <ButtonText isSubmitting={isSubmitting}>{children}</ButtonText>

      {isSubmitting && (
        <SpinnerContainer>
          <Spinner size="small" flavor={fancy ? 'pale' : 'green'} />
        </SpinnerContainer>
      )}
    </Button>
  );
};

const FormSubmitButtons = {
  Row,
  Cancel,
  Submit,
};

export { FormSubmitButtons };

const SpinnerContainer = styled.div`
  position: absolute;
  left: 50%;
  top: calc(50% + 2px);
  transform: translate(-50%, -50%);
`;

const ButtonText = styled.span`
  ${props =>
    props.isSubmitting &&
    `
   color: transparent;
   visibility: hidden;
 `}
`;

const Container = styled.div`
  font-family: Untitled Sans, sans-serif;
  ${props => !props.compact && 'margin-top: 20px;'}
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  width: 100%;
`;

const ControlSet = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  align-items: center;

  &:last-child {
    margin-left: auto;
  }
`;

const CancelLink = styled.a`
  padding: ${padding.small} 0;
  cursor: pointer;
  color: ${colors.mediumBlue} !important;
  text-decoration: none;
  font-size: 14px;
`;
